import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { VisaFormApi } from "../../../api/visa-form/visa-form.api";
import { VisaTypeApi } from "../../../api/visa-type/visa-type.api";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { VisaRequestFrontApi } from "../../../api/visa-request-front/visa-request-front.api";
import { dateToView } from "../../../utils/date.utils";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus, STATUS_VISA } from "../manage-request/enum/request-form.enum";
import { VisaIntendantApi } from "../../../api/visa-intendant/visa-intendant.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { CourseOfStudyApi } from "../../../api/course-of-study/course-of-study.api";
import { RootState } from "../../../store/store";
import { checkPermission, permission_config } from "../../../utils/app.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission(`VISA_INTENDANT`, permission)
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");
    const [dataEmployee, setDataEmployee] = useState<any[]>([]);
    const [courseOfStudy, setCourseOfStudy] = useState<any[]>([]);

    const [data, setData] = useState<any[]>([]);
    const [visaType, setVisaType] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [id_course_of_study, set_id_course_of_study,] = useState<string>("ALL");


    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<any>({
        fullname: '',
        degree_name: '',
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_form({
            fullname: '',
            degree_name: '',
        })
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 300, align: "left", label: t("ชื่อ-นามสกุล")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "left", label: t("ตำแหน่ง")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "left", label: t("หลักสูตรที่ดูแล")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 280, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },


        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 150, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            employee_name,
            created_date,
            modified_date,
            id_visa_intendant,
            df_name,
            roles_name,
            modified_name,
            create_name
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: employee_name || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: roles_name || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: df_name || "-",
                },

                {
                    option: "TEXT",
                    align: "left",
                    label: modified_name || create_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateToView(modified_date) : created_date ? dateToView(created_date) : "-",
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.request_form.manage_request_form_detail.replace(':id', id_visa_form))}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit={checkPermit?.isUpdate}
                            enableView={checkPermit?.isView}
                            enableDelete={checkPermit?.isDelete}
                            onViewClick={() => {
                                setShowModal('VIEW');
                                // set_form(objData)
                                findById(id_visa_intendant)
                                // set_id_gallery_type(id_gallery_type)
                            }}
                            onEditClick={() => {
                                setShowModal('EDIT');
                                // set_form(objData)
                                findById(id_visa_intendant)
                                // set_id_gallery_type(id_visa_intendant)
                            }}
                            onDeleteClick={() => handleDeleteList(id_visa_intendant)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_visa_intendant: number) => {
        alertActive(t("ผู้ดูแลหลักสูตร"), t("ต้องการลบผู้ดูแลหลักสูตร ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await VisaIntendantApi.delete(id_visa_intendant).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ผู้ดูแลหลักสูตร"), t("ผู้ดูแลหลักสูตร เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ผู้ดูแลหลักสูตร"), t("ผู้ดูแลหลักสูตร ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (id_course_of_study && id_course_of_study !== 'ALL') query = { ...query, id_course_of_study: id_course_of_study }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }

        dispatch(setLoading());
        await VisaIntendantApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_course_of_study, keyword, startDate, endDate])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    const findById = async (id: any) => {

        await VisaIntendantApi.findById(id).then((res) => {
            if (res.status < 300) {
                set_form({
                    ...res.data?.data,
                    ...res.data?.data?.employee,
                    fullname: `${res.data?.data?.employee?.first_name} ${res.data?.data?.employee?.last_name}`,
                    ...res.data?.data?.degree,
                    ...res.data?.data?.faculty
                });
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const getDataEmployee = async () => {
        let query: any = {
            page: 1,
            limit: 1000000,
        };

        const res = await EmployeeApi.list(query);
        const data = res.data;
        if (data.status < 300) {
            setDataEmployee(data.data.items);
        } else {
            setDataEmployee([]);
        }
    };
    const getCourseOfStudy = async () => {
        let query: any = {
            page: 1,
            limit: 1000000,
        };

        const res = await CourseOfStudyApi.list(query);
        const data = res.data;
        if (data.status < 300) {
            setCourseOfStudy(data.data.items);
        } else {
            setCourseOfStudy([]);
        }
    };

    useEffect(() => {
        getVisaType()
        getDataEmployee()
        getCourseOfStudy()
    }, [])
    const handleSubmitForm = async () => {
        const body = {
            "id_course_of_study": form?.id_course_of_study,
            "id_degree": form?.id_degree,
            "id_faculty": form?.id_faculty,
            "id_employee": form?.id_employee,
            'intendant_type': form?.intendant_type
        }
        dispatch(setLoading());
        if (form?.id_visa_intendant) {
            await VisaIntendantApi.patch(form?.id_visa_intendant, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขผู้ดูแลหลักสูตร"), t('แก้ไขผู้ดูแลหลักสูตร เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขผู้ดูแลหลักสูตร"), t("แก้ไขผู้ดูแลหลักสูตร ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await VisaIntendantApi.post(body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("สร้างผู้ดูแลหลักสูตร"), t("สร้างผู้ดูแลหลักสูตร เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("สร้างผู้ดูแลหลักสูตร"), t("สร้างผู้ดูแลหลักสูตร ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        visaType,
        status,
        set_status,

        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        dataEmployee,
        courseOfStudy,
        id_course_of_study,
        set_id_course_of_study,
        checkPermit
    }
}

export default ManageState